import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

interface NavItem {
  label: string;
  type: "route" | "section";
  target: string;
}

const navItems: NavItem[] = [
  { label: "人物档案库", type: "route", target: "/renwu" },
  { label: "最新动态", type: "section", target: "dynamics" },
  { label: "追踪方法", type: "section", target: "method" },
  { label: "常见问题", type: "section", target: "faq" },
  { label: "关于我们", type: "route", target: "/guanyu" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleItem = (item: NavItem) => {
    setOpen(false);
    if (item.type === "route") {
      navigate(item.target);
      return;
    }
    if (location.pathname !== "/") {
      navigate("/");
      window.setTimeout(() => {
        document
          .getElementById(item.target)
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    } else {
      document
        .getElementById(item.target)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <Link
          to="/"
          className="flex items-center gap-2.5 whitespace-nowrap"
          aria-label="焦点人物志 首页"
        >
          <span className="flex h-8 w-8 items-center justify-center bg-primary-500 text-background-50">
            <i className="ri-user-search-line text-lg"></i>
          </span>
          <span className="font-display text-xl font-bold tracking-wide text-foreground-950">
            焦点人物志
          </span>
          <span className="mt-1 hidden text-[11px] font-medium tracking-widest text-secondary-700 sm:inline">
            最新爆料 · 人物追踪
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <button
              key={item.label}
              type="button"
              onClick={() => handleItem(item)}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/renwu"
            className="ml-3 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            进入档案库
          </Link>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-950 md:hidden"
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <button
                key={item.label}
                type="button"
                onClick={() => handleItem(item)}
                className="rounded-md px-3 py-2.5 text-left text-sm font-medium text-foreground-800 transition-colors hover:bg-secondary-100"
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/renwu"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              进入档案库
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}